import { render, staticRenderFns } from "./private.vue?vue&type=template&id=21c0692b&scoped=true"
import script from "./private.vue?vue&type=script&lang=js"
export * from "./private.vue?vue&type=script&lang=js"
import style0 from "./private.vue?vue&type=style&index=0&id=21c0692b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c0692b",
  null
  
)

export default component.exports